import isAdminProfileUtil from '../../../../../models/profile/utils/is-admin'
import { getProfileIdModelUtil } from '../../../../../models/utils/get-profile-id'
import { canEditWorkoutUtil } from '../../../../../modules/workout/model/utils/can-edit'
import getCurrentCreatorClientIdSelect from '../../../../creator-client/state/selectors/get-current-client-id'
import { getCurrentProfileSelect } from '../../../../profile/redux/selectors/get-current'
import getByIdWorkoutSelector from '../get-by-id'
import { createSelector } from 'reselect'

function canEditByIdWorkoutSelector (id) {
  return createSelector(
    getByIdWorkoutSelector(id),
    getCurrentProfileSelect,
    getCurrentCreatorClientIdSelect,
    (workout, profile, clientId) => {
      return (
        canEditWorkoutUtil(workout, profile) ||
        getProfileIdModelUtil(workout) ===
        clientId ||
        isAdminProfileUtil(profile)
      )
    }
  )
}

export default canEditByIdWorkoutSelector
